import { useAtom } from 'jotai';
import { ReactNode } from 'react';
import { Address } from 'viem';
import { atomTwitterModal } from '~/blinko/modals/connect.twitter.modal';
import { ProfileSlot } from './ProfileSlot';

interface TwitterSlotProps {
  address: Address;
  children: ({ connected, connect, profileLink }: { connected: boolean, connect: () => void, profileLink: string }) => ReactNode;
}

export const TwitterSlot: React.FC<TwitterSlotProps> = ({ address, children }) => {
  const [, setVisible] = useAtom(atomTwitterModal.visible);
    
  const connectTwitter = () => {
    setVisible(true);
  };

  return (
    <ProfileSlot address={address}>
      {({ profile }) => {
        const handle = profile.twitterHandle || profile.twitterUsername || profile.name || '';
        const sanitizedHandle = handle.startsWith('@') ? handle.slice(1) : handle;
        const profileLink = sanitizedHandle ? `https://x.com/${sanitizedHandle}` : '';
        return children({ connected: Boolean(profile.twitterHandle), connect: connectTwitter, profileLink });
      }}
    </ProfileSlot>
  );
};
